import { buttonFunctions } from "../cta/cta.helper";

const LINK_TO_PAGE = `options.get('clickFunction') === '${buttonFunctions.linkToPage}'`;

/**
 * The CTA link inputs for the COM-945 components (Featured 3-Up, Feature
 * Cards, Feature Hero): the Button's editor minus the page reference and
 * "Is SFRA". Internal links are a typed Custom URL; external links are an
 * External Link reference. Safe inside a list row: every `showIf` reads only
 * sibling fields of the same row.
 */
export const featureLinkInputs = [
  {
    name: "clickFunction",
    friendlyName: "Click function",
    type: "text",
    enum: Object.values(buttonFunctions),
    required: true,
    defaultValue: buttonFunctions.linkToPage,
    helperText:
      "Link to another page, scroll to an element on this page, or do nothing.",
  },
  {
    name: "scrollTargetId",
    friendlyName: "Scroll target ID",
    type: "text",
    required: true,
    showIf: `options.get('clickFunction') === '${buttonFunctions.linkToElement}'`,
    helperText: "The ID of the element on this page to scroll to.",
  },
  {
    name: "isInternalLink",
    friendlyName: "Is internal link",
    type: "boolean",
    defaultValue: true,
    showIf: LINK_TO_PAGE,
    helperText:
      "On: type the page's URL in Custom URL. Off: pick an External Link.",
  },
  {
    name: "customUrl",
    friendlyName: "Custom URL",
    type: "text",
    required: true,
    showIf: `${LINK_TO_PAGE} && options.get('isInternalLink') !== false`,
    helperText: "A path on this site, e.g. /best-sellers",
  },
  {
    name: "externalLinkReference",
    friendlyName: "External link reference",
    type: "reference",
    model: "external-links",
    required: true,
    showIf: `${LINK_TO_PAGE} && options.get('isInternalLink') === false`,
    helperText:
      "If the link shows as unlinked in preview, pick the reference again and check that it is published.",
  },
  {
    name: "openInNewTab",
    friendlyName: "Open in new tab",
    type: "boolean",
    defaultValue: false,
    showIf: LINK_TO_PAGE,
  },
  {
    name: "isRevShare",
    friendlyName: "Is Rev-Share",
    type: "boolean",
    defaultValue: false,
    showIf: LINK_TO_PAGE,
    helperText: 'Select "true" if the link is a Rev-Share link.',
  },
];
